<div class="license">
  <div #template></div>
</div>